import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanDeactivate, Router } from '@angular/router';
import { BillingComponent } from "../../components/billing/billing.component";
import { PermissionsService } from "../permissions/permissions.service";

@Injectable({
  providedIn: 'root'
})
export class BillingGuards implements CanActivate, CanDeactivate<BillingComponent> {
  constructor(
    private permissionsService: PermissionsService,
    private router: Router
  ) {
  }

  /**
   * Guard for accessing routes - controls who can access billing page and other pages
   */
  canActivate(route: ActivatedRouteSnapshot): boolean {
    // Handle access to the billing page
    if (route.routeConfig?.path === 'billing') {
      // Check if user is a signup user who needs billing
      const isSignUpUser = this.permissionsService.isSignUpUser;

      // If user doesn't need billing, redirect to requests
      if (!isSignUpUser) {
        this.router.navigate(['/requests']);
        return false;
      }

      // Allow access to billing page for users who need it
      return true;
    }

    // Handle access to other protected pages
    const isSignUpUser = this.permissionsService.isSignUpUser;

    // If user needs billing, redirect to billing page
    if (isSignUpUser) {
      this.router.navigate(['/billing']);
      return false;
    }

    // Allow access to all routes when the user doesn't need billing
    return true;
  }

  /**
   * Guard to prevent leaving the billing page if billing is required
   */
  canDeactivate(component: BillingComponent): boolean {
    const isSignUpUser = this.permissionsService.isSignUpUser;

    // Allow navigation away only if user doesn't need billing
    return !isSignUpUser;
  }
}
